// import React from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import VegIcon from "../../Assets/vegIcon.png"
// import NonVegIcon from "../../Assets/nonVegIcon.png"
// import './ItemDetailPage.scss';
// import { diet } from "../../Utills/enums";
// import {IMAGE_BASE_URL} from "../../Utills/config"

// const ItemDetailPage = () => {
//   const { menuId } = useParams();
//   const navigate = useNavigate();
//   const menu = useSelector((state) => state?.user.menu);

//   const categories = menu?.categories || [];

//   const item = categories
//     .flatMap((cat) => cat.items)
//     .find((i) => i.menuId === menuId);

//   if (!item) return <p className="not-found">Item not found</p>;
// console.log("item",item)
//   return (
//     <div className="item-detail-page">

//   <button className="back-btn round-close-btn" onClick={() => navigate(-1)}>✕</button>

// {item.imageUrl && item.imageUrl.trim() !== "" ? (
//   item.imageUrl.includes(IMAGE_BASE_URL) || item.imageUrl.includes("https") ? (
//     <img src={item.imageUrl} className="item-detail-img" />
//   ) : (
//     <img src={IMAGE_BASE_URL + item.imageUrl} className="item-detail-img" />
//   )
// ) : null}

//   <div className="item-detail-content">

//     <div className="title-row">
//       <div className="item-title">
//         <img src={diet[item.foodTypeId ]=== 'Veg' || diet[item.foodTypeId ] === 'Vegan' ? VegIcon : NonVegIcon} />
//         {item.foodName}
//       </div>
//       {/* <div className="fav-icon">♡</div> */}
//     </div>

//     <div className="item-price">₹ {item.price}</div>

//     <p className="item-description">{item.description}</p>

//   </div>

// </div>

//   );
// };

// export default ItemDetailPage;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import VegIcon from "../../Assets/vegIcon.png";
import NonVegIcon from "../../Assets/nonVegIcon.png";
import { ArrowLeft, Minus, Plus, ShoppingBag } from "lucide-react";
import "./ItemDetailPage.scss";
import { diet } from "../../Utills/enums";
import { IMAGE_BASE_URL } from "../../Utills/config";
import { addItem, fetchMenuData, removeItem } from "../../redux/action";
import SizeCustomizationModal from "../../component/MenuCard/SizeCustomization";

const ItemDetailPage = () => {
  const { menuId, id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);

  const menu = useSelector((state) => state?.user.menu);
  const loading = useSelector((state) => state?.user.loading);
  const cart = useSelector((state) => state?.user.cart || {});
  const { table } = useParams();
  const isGuest =
    sessionStorage.getItem("packageType") === "catelog" || table === "cat";

  const categories = menu?.categories || [];

  // Fetch menu on refresh if not present in Redux
  useEffect(() => {
    if ((!categories || categories.length === 0) && id) {
      dispatch(fetchMenuData(id));
    }
  }, [categories, id, dispatch]);

  const category = categories.find((cat) =>
    (cat.items || []).some((entry) => String(entry.menuId) === String(menuId)),
  );
  const item = category?.items.find(
    (entry) => String(entry.menuId) === String(menuId),
  );

  // Show loading while menu data is being fetched
  if (loading || (!item && categories.length === 0)) {
    return <main className="item-detail-state">Loading item details...</main>;
  }

  if (!item) return <main className="item-detail-state">Item not found</main>;

  const hasVariants =
    item.menuSizeOptions?.some((option) => option.isActive !== false) || false;
  const activeVariants =
    item.menuSizeOptions?.filter((option) => option.isActive !== false) || [];
  const lowestPrice = hasVariants
    ? Math.min(...activeVariants.map((option) => option.price))
    : item.price;
  const isAvailable = Boolean(item.isAvailable) && item.isActive !== false;
  const quantity = Object.values(cart)
    .filter((entry) => String(entry.id) === String(item.menuId))
    .reduce((total, entry) => total + (entry.selected || 0), 0);
  const imageUrl = item.imageUrl
    ? item.imageUrl.includes("https") || item.imageUrl.includes(IMAGE_BASE_URL)
      ? item.imageUrl
      : IMAGE_BASE_URL + item.imageUrl
    : null;

  const handleAdd = () => {
    if (!isAvailable || isGuest) return;
    if (hasVariants) {
      setIsVariantModalOpen(true);
      return;
    }
    dispatch(addItem({ id: item.menuId, selectedTab: category.categoryId }));
  };

  const handleRemove = () => {
    if (quantity > 0 && !hasVariants) {
      dispatch(removeItem({ id: item.menuId, selectedTab: category.categoryId }));
    }
  };

  return (
    <main className="item-detail-page">
      <div className={`item-detail-hero${imageUrl ? " has-image" : ""}`}>
        {imageUrl && (
          <img src={imageUrl} alt={item.foodName} className="item-detail-img" />
        )}
        <button
          className="item-detail-back"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          title="Go back"
        >
          <ArrowLeft size={20} />
        </button>
      </div>

      <article className="item-detail-content">
        <div className="item-detail-category">{category?.categoryName}</div>
        <div className="item-detail-title-row">
          <img
            src={
              diet[item.foodTypeId] === "Veg" ||
              diet[item.foodTypeId] === "Vegan"
                ? VegIcon
                : NonVegIcon
            }
            alt={diet[item.foodTypeId] || "Food type"}
            className="item-detail-diet-icon"
          />
          <h1 className="item-title">{item.foodName}</h1>
        </div>

        <div className="item-detail-price">
          ₹{lowestPrice}
          {hasVariants && <span> onwards</span>}
        </div>

        {item.description?.trim() ? (
          <p className="item-description">{item.description}</p>
        ) : (
          <p className="item-description item-description-empty">
            Freshly prepared to order.
          </p>
        )}

        {hasVariants && (
          <div className="item-detail-customization-hint">
            <span>Available in {activeVariants.length} sizes</span>
            <span>Choose a size when adding</span>
          </div>
        )}
      </article>

      {!isGuest && (
        <div className="item-detail-action-bar">
          <div className="item-detail-action-price">
            <span>{hasVariants ? "Starting at" : "Price"}</span>
            <strong>₹{lowestPrice}</strong>
          </div>
          {!isAvailable ? (
            <button className="item-detail-add-button" disabled>
              Currently unavailable
            </button>
          ) : hasVariants ? (
            <button
              className="item-detail-add-button"
              onClick={handleAdd}
              aria-label={`Choose a size for ${item.foodName}`}
            >
              <ShoppingBag size={18} />
              Choose size
            </button>
          ) : quantity > 0 ? (
            <div className="item-detail-quantity-control" aria-label="Quantity">
              <button onClick={handleRemove} aria-label="Remove one">
                <Minus size={18} />
              </button>
              <span>{quantity}</span>
              <button onClick={handleAdd} aria-label="Add one">
                <Plus size={18} />
              </button>
            </div>
          ) : (
            <button className="item-detail-add-button" onClick={handleAdd}>
              <ShoppingBag size={18} />
              Add to cart
            </button>
          )}
        </div>
      )}

      {hasVariants && !isGuest && (
        <SizeCustomizationModal
          isOpen={isVariantModalOpen}
          onClose={() => setIsVariantModalOpen(false)}
          item={{ ...item, categoryId: category.categoryId }}
          isGuestUser={isGuest}
        />
      )}
    </main>
  );
};

export default ItemDetailPage;
